/**
 * IGT / RXConnect Meter_* pipe extract — 15 columns, 9 cumulative meters (cols 2–10).
 *
 * ClubApp Meter extract mapping (IGT):
 *   col 7 → MtrMoneyIn (Meter.mtrMoneyIn) → CashIn
 *   col 8 → MtrInTickets (Meter.mtrMoneyInTickets) → TicketsIn
 *
 * Col 9 is unused (always 0). Bill denomination counters are not in this gateway feed.
 * CashlessIn / CashlessOut are not supplied on RXConnect Meter_* for Wests.
 */

export const IGT_METER_PIPE_SOURCE_LABELS = {
  0: 'egm_id',
  1: 'snapshot_time',
  2: 'turnover',
  3: 'credit_win',
  4: 'cancel_credit',
  5: 'stroke',
  6: 'credit',
  7: 'mtr_money_in',
  8: 'mtr_money_in_tickets',
  9: 'unused_meter_9',
  10: 'cash_drop',
  11: 'machine_status',
  12: 'valid_flag',
  13: 'site_name',
  14: 'site_name_dup',
}

export const IGT_METER_PIPE_MAPPINGS = {
  EgmPK: 'egm_id',
  SnapshotTime: 'snapshot_time',
  GamingDate: '',
  MeterReadTime: '',
  Turnover: 'turnover',
  CreditWin: 'credit_win',
  CancelCredit: 'cancel_credit',
  Stroke: 'stroke',
  Credit: 'credit',
  CashlessIn: '',
  CashlessOut: '',
  CashIn: 'mtr_money_in',
  CashDrop: 'cash_drop',
  CoinOut: '',
  Bill5: '',
  Bill10: '',
  Bill20: '',
  Bill50: '',
  Bill100: '',
  TicketsIn: 'mtr_money_in_tickets',
  Venue: 'site_name',
}

/** PaySafeGo meter fields not supplied by RXConnect Meter_* (full PSG / XLSX vendors only). */
export const METER_PSG_ONLY_FIELDS = new Set([
  'GamingDate',
  'MeterReadTime',
  'CoinOut',
  'Bill5',
  'Bill10',
  'Bill20',
  'Bill50',
  'Bill100',
  'CashlessIn',
  'CashlessOut',
])

export const METER_FIELD_HINTS = {
  EgmPK: 'Col 0 — vendor machine id (map to house # via DimMachine)',
  SnapshotTime: 'Col 1 — 15-min snapshot timestamp',
  Turnover: 'Col 2 — cumulative turnover meter',
  CreditWin: 'Col 3 — cumulative credit win',
  CancelCredit: 'Col 4',
  Stroke: 'Col 5',
  Credit: 'Col 6 — credit meter (machine credits balance, not credit win)',
  CashlessIn: 'Map when vendor supplies cashless-in meter',
  CashlessOut: 'Map when vendor supplies cashless-out meter',
  CashIn: 'Col 7 — MtrMoneyIn (ClubApp Meter.mtrMoneyIn)',
  CashDrop: 'Col 10 — sparse on Wests',
  TicketsIn: 'Col 8 — MtrInTickets (ClubApp Meter.mtrMoneyInTickets)',
  Venue: 'Col 13 — site name',
  CoinOut: 'Coin out meter — map when vendor supplies it',
  Bill5: 'Bill acceptor $5 count',
  Bill10: 'Bill acceptor $10 count — used by bill-stuffing rules',
  Bill20: 'Bill acceptor $20 count',
  Bill50: 'Bill acceptor $50 count',
  Bill100: 'Bill acceptor $100 count',
  GamingDate: 'Trading day — map when vendor supplies it',
  MeterReadTime: 'Clock time of meter read when separate from snapshot',
}

export function referenceIgtMeterTemplateContent() {
  return {
    sourceFormat: 'pipe-delimited',
    hasHeader: false,
    vendorNotes:
      'RXConnect Meter_* — col 7 MtrMoneyIn→CashIn, col 8 MtrInTickets→TicketsIn; col 9 unused.',
    sourceLabels: { ...IGT_METER_PIPE_SOURCE_LABELS },
    mappings: { ...IGT_METER_PIPE_MAPPINGS },
  }
}

export const IGT_METER_TEMPLATE_JSON = referenceIgtMeterTemplateContent()
